import { useTranslation } from "react-i18next";
import style from "./ButtonGroup.module.scss";
import {
  ADMIN_PANEL_PATH,
  MARATHONS_PATH,
  STEP1_CONTENT_PATH,
  STEP2_SETTINGS_PATH,
} from "pages/paths";
import { createPaths } from "shared/lib/createPaths";
import { useNavigate } from "react-router-dom";

interface ButtonGroupProps {
  value: number;
  isEditMode: boolean;
  params?: any;
  setConfirmationModalOpen?: React.Dispatch<React.SetStateAction<boolean>> | undefined;
  isDirty?: boolean;
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  value,
  isEditMode,
  params,
  setConfirmationModalOpen,
  isDirty
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNextPage = () => {
    if (isEditMode) {
      if (value === 2) {
        navigate(
          createPaths(
            ADMIN_PANEL_PATH,
            MARATHONS_PATH,
            params.id,
            STEP2_SETTINGS_PATH
          )
        );
      } else {
        const languageMap = ["ru", "en", "kg"];
        const nextLanguage = languageMap[value + 1];
        navigate(
          createPaths(
            ADMIN_PANEL_PATH,
            MARATHONS_PATH,
            params.id,
            STEP1_CONTENT_PATH,
            nextLanguage
          )
        );
      }
    } else {
      if (value === 2) {
        navigate("/new/step-2");
      } else {
        const languageMap = ["ru", "en", "kg"];
        const nextLanguage = languageMap[value + 1];
        navigate(`/new/step-1?language=${nextLanguage}`);
      }
    }
  };

  const handlePrevPage = () => {
    if (isEditMode) {
      if (value === 0) {
        navigate(createPaths(ADMIN_PANEL_PATH, MARATHONS_PATH));
      } else {
        const languageMap = ["ru", "en", "kg"];
        const prevLanguage = languageMap[value - 1];
        navigate(
          createPaths(
            ADMIN_PANEL_PATH,
            MARATHONS_PATH,
            params.id,
            STEP1_CONTENT_PATH,
            prevLanguage
          )
        );
      }
    } else {
      if (value === 0) {
        if (isDirty) {
          setConfirmationModalOpen?.(true);
        } else {
          navigate(createPaths(ADMIN_PANEL_PATH, MARATHONS_PATH));
        }
      } else {
        const languageMap = ["ru", "en", "kg"];
        const prevLanguage = languageMap[value - 1];
        navigate(`/new/step-1?language=${prevLanguage}`);
      }
    }
  };

  return (
    <div className={style.box_bottom}>
      <button className={style.btn_back} onClick={handlePrevPage} type="button">
        {value === 0 ? t("createMarathon.cancel") : t("createMarathon.back")}
      </button>
      <button className={style.btn_next} type="button" onClick={handleNextPage}>
        {value === 2 ? t("createMarathon.next") : t("createMarathon.next")}
      </button>
    </div>
  );
};
